import React, { useState } from 'react';
import cn from './style.module.scss';
interface Tab {
  title: string;
  content: React.ReactNode;
}
interface TabComponentProps {
  tabs: Tab[];
  className?: string; // Optional className prop
  tabClass?: string; // Optional className prop
  activeClassName?: string;
}
const TabComponent: React.FC<TabComponentProps> = ({
  tabs,
  className,
  tabClass,
  activeClassName,
}) => {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <div className={`${cn.tabWrapper} ${className}`}>
      <div className={`${cn.tabNavigation} ${tabClass}`}>
        <ul className={cn.tabsList}>
          {tabs.map((tab, index) => (
            <li key={index}>
              <a
                className={`${cn.tabLink}  ${
                  activeTab === index
                    ? `${activeClassName} ${cn['activeLink']}`
                    : ''
                }`}
                onClick={() => setActiveTab(index)}
              >
                {tab.title}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className={cn.tabContent}>{tabs[activeTab].content}</div>
    </div>
  );
};

export default TabComponent;
